/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import ddarrow from "../../assets/image/ddarrow.svg";
import Export from "../../assets/image/Export.svg";
import INFO from "../../assets/image/INFO.svg";
import NO from "../../assets/image/No.svg";
import YesTick from "../../assets/image/YesTick.svg";
import {ClearFormSetFutios,getFormDate,getOnsearch,getRecipentId,getStatus,getToDate,getUserId,} from "../../redux/actions/adminAction";
import { ExportData } from "../commonModel/commonExport";
import CommonPagination from "../commonModel/commonPagination";
import Tooltip from "./Tooltip";
import useOutsideClick from "./useOutsideClick";
import moment from "moment";
const ReusableTable = ({
  headers = [],
  data = [],
  renderRow,
  paginationObject = {},
  filters = {},
  onExport,
  currentPage,
  handlePageChange,
  height,
  userFilterlabel,
  callBackReset
}) => {
  const [FromDate, setFromDate] = useState(null);
  const [ToDate, setToDate] = useState("");
  const [period, setPeriod] = useState("");
  const [active, setActive] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [optionVal, setOptionValue] = useState("");
  const [recipient,setReCipient] = useState("");
  const [count, setCount] = useState(0);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams()
  const { accessToken, formDate,search,userId,recipientId } = useSelector((state) => state.adminReducers);
  const LocationURL = useLocation().pathname;
  const [visibleColumns, setVisibleColumns] = useState(headers?.map((header) => header?.key));
  const LocationRoute = useLocation()?.pathname?.split("/")[1];
  const [open, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useOutsideClick(dropdownRef, () => setIsOpen(false), open); 

  const handleColumnToggle = (key) => {
   setVisibleColumns((prev) =>
     prev?.includes(key) ? prev?.filter((k) => k !== key) : [...prev, key]
   );
  };

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  useEffect(() => {
    if (LocationRoute === "order-report") {
      setFromDate(firstDayOfMonth);
      setToDate(today);
      dispatch(getFormDate(firstDayOfMonth));
      dispatch(getToDate(today));
    }
  }, [LocationRoute]);

  const handleChange = (e) => {
    dispatch(getStatus(e?.value));
    setActive(e?.value);
  };
  const RegionValueSelect = (value) => {
    if (value !== null) {
      setOptionValue(value);
      dispatch(getUserId(value?.key));
    } else {
      setOptionValue("");
      dispatch(getUserId(""));
    }
  };
  const  RecipientChange = (value) => {
    if (value !== null) {
      setReCipient(value);
      dispatch(getRecipentId(value?.key));
    } else {
      setReCipient("");
      dispatch(getRecipentId(""));
    }
  };

  const periodOptions = [
    { value: "all", label: "All" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ];
  const DateStartGet = (date) => {
    if (date) {
      setFromDate(date);
      dispatch(getFormDate(date));
    } else {
      setFromDate("");
      dispatch(getFormDate(""));
    }
  };

  const DateEndGet = (date) => {
    if (date === null) {
      setToDate("");
      dispatch(getToDate(""));
    } else {
      setCount((prevCount) => prevCount + 1);
      if (count === 0) {
        const newDate = new Date(date);
        newDate.setHours(11);
        newDate.setMinutes(45);
        setToDate(newDate);
        dispatch(getToDate(date));
      } else {
        dispatch(getToDate(date));
        setToDate(date);
      }
    }
  };
 const [loading,setLoading]  = useState(false)

  const handleExport = async () => {
    setLoading(true)
    if (LocationURL === "/transaction-management") {
      const url = `${process.env.REACT_APP_BASE_URL}tcn/export/transactions/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "transactions",search,userId,recipientId,);
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }
    if(LocationURL === "/user-management") {
      const url = `${process.env.REACT_APP_BASE_URL}user/export/user/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "user",search,userId,recipientId);
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }
    if(LocationURL === "/machine-management") {
      const url = `${process.env.REACT_APP_BASE_URL}machine/export/machine/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "machine",search,userId,recipientId);
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }
    if (LocationURL === "/order-management") {
      const url = `${process.env.REACT_APP_BASE_URL}tcn/export/order/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "order",search,userId,recipientId);
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }
    if(LocationURL===`/view-report/${params?.id}`){
      const url = `${process.env.REACT_APP_BASE_URL}tcn/export/order/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "order",search,userId,recipientId,params?.id,"PAID");
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }
    if (LocationURL === "/payment-management") {
      const url = `${process.env.REACT_APP_BASE_URL}payment/export/payment/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "payment",search,userId,recipientId,);
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }
     if (LocationURL === "/recipient-management") {
      const url = `${process.env.REACT_APP_BASE_URL}user/export/recipient/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "recipient",search,userId,recipientId);
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }
       if (LocationURL === "/order-report") {
      const url = `${process.env.REACT_APP_BASE_URL}tcn/export/order_report/`;
      try {
        await ExportData(url, accessToken, formDate, ToDate, "order_report",search,"",recipientId,userId);
      } catch (error) {
        console.log("Error while exporting data:", error);
      }
    }

    setTimeout(() => {
        setLoading(false); 
    }, 2000);

  };
  const headerMap = {
    "/user-management": "User Management",
    "/order-management": "Order Management",
    "/machine-management": "Machine Mapping",
    "/add-machine": "+ Machine Mapping",
    "/contact-us": "Contact Management",
    "/payment-management": "Payment Management",
    "/transaction-management": "Transaction – Purchase/Transfer/Withdraw",
    "/refund": "Withdraw Records",
    "/page": "Pages",
    "/add-faq": "+ FAQ Management",
    "/add-benefit": "+ Benefits",
    "/faq": "FAQ Management",
    "/benefit": "Benefits",
    "/banner": "Banner",
    "/report-an-history": "Report an History",
    "/recipient-management": "Recipient Management",
    "/order-report": "Order Report",
    "/withdraw-records": "Withdraw Records",
  };

  const routeMap = {
    "edit-faq": "Edit Faq",
    "edit-machine": "Edit Machine",
    "view-report": "View Transactions",
  };

  const text = headerMap[LocationURL] || routeMap[LocationRoute];
  const ResetFilter =() =>{
        dispatch(getOnsearch(""))
        dispatch(getStatus(""))
        dispatch(getUserId(""))
        dispatch(getRecipentId(""))
        dispatch(getFormDate(""))
        dispatch(getToDate(""))
        setFromDate("")
        setToDate("")
        setPeriod("")
        setActive("")
        setSearchQuery("")
        setOptionValue("")
        setReCipient("")
  }
  const handleDailyClick = () => {
            const todayFormatted = moment().format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            dispatch(getFormDate(todayFormatted));
            dispatch(getToDate(todayFormatted));
  };
  const handleWeeklyClick = () => {
            const startOfWeek = moment().startOf('week').format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            const endOfWeek = moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            dispatch(getFormDate(startOfWeek));
            dispatch(getToDate(endOfWeek));
  };
  const handleMonthlyClick = () => {
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        const endOfMonth = moment().endOf('month').format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        dispatch(getFormDate(startOfMonth));
        dispatch(getToDate(endOfMonth));
  };
  const handleAllClick = () => {
        dispatch(getFormDate(""));
        dispatch(getToDate(""));
  };
  const callHandleChange = (event) => {
            setPeriod(event)
            switch (event?.value) {
                case 'daily':
                    handleDailyClick();
                    break;
                case 'weekly':
                    handleWeeklyClick();
                    break;
                case 'monthly':
                    handleMonthlyClick();
                    break;
                case 'all':
                    handleAllClick();
                    break;
                default:
                    break;
            }
  };
  return (
    <div className="" id="tabel_component">
      {Object.keys(filters)?.length > 0 && (
        <>
          <div className="new_wrapper_of_header">
            {text ? <p className="header-text mb-1">{text}</p> : null}
            <div className="new_sub_wrapper_of_header">
              {filters?.search && (
                <div className="search-bar ">
                  <span className="search-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1126_461)">
                        <path
                          d="M8.75 15C12.2018 15 15 12.2018 15 8.75C15 5.29822 12.2018 2.5 8.75 2.5C5.29822 2.5 2.5 5.29822 2.5 8.75C2.5 12.2018 5.29822 15 8.75 15Z"
                          stroke="#1C1C1C"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.1694 13.1694L16.5 16.5"
                          stroke="#1C1C1C"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1126_461">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <input
                    type="text"
                    className="search-input  Poppins_400"
               placeholder={
                 filters?.searchPlaceholder?.length > 38
                ? `${filters.searchPlaceholder.slice(0, 38)}...`
                : filters?.searchPlaceholder
                }
                    onChange={(e) => {
                      const newText = e.target.value
                      dispatch(getOnsearch(newText.trim()));
                      setSearchQuery(newText);
                    }}
                    onKeyDown={(e) =>
                      dispatch(getOnsearch(e.target.value.trim()))
                    }
                    value={searchQuery}
                  />
                  <div
                  className="filter_search_input" 
                  >
                    <img src={INFO} alt="Info" className="w-100" style={{cursor:"pointer"}}
                          onMouseEnter={() => setIsTooltipVisible(true)}
                          onMouseLeave={() => setIsTooltipVisible(false)}/>
                          <Tooltip width="200px" text={filters?.searchPlaceholder} isVisible={isTooltipVisible} />

                  </div>
                </div>
              )}
              <div style={{ position: "relative" }} ref={dropdownRef}>
                <p
                  className="Poppins_400 column_button"
                  onClick={() => setIsOpen(!open)}>
                  Column{" "}
                  <span>
                    <img src={ddarrow} alt="down arrow" />
                  </span>
                </p>
                {open && (
                  <div className="column_filter_div">
                    {headers?.map((header, index) =>{
                        const isChecked = visibleColumns.includes(header.key);
                      return(
                        // eslint-disable-next-line react/jsx-no-undef
                        <React.Fragment key={index}>
                      {header.name === "" ? null : (
                        <div
                          key={index}
                          className="filter_object_div"
                        >
                                <div
        onClick={() => handleColumnToggle(header.key)}
        className="filter_sub_div"
        style={{
          backgroundColor: isChecked ? "#ddf2ea" : "#F2F2F2",
          border: isChecked ?  "1px solid #ddf2ea":"1px solid #E0E0E0",          
        }}
      >
        <img
          src={isChecked ? YesTick : NO}
          alt={isChecked ? "Yes" : "No"}
          className="filter_yes_no_img"
        />
      </div>

                          <label
                            className="form-check-label  Poppins_400_for_colom_filter filter_label" 
                            htmlFor={`col-check-${index}`}
                          >
                            {header.name}
                          </label>
                        </div>
                      )}
                        </React.Fragment>
                      )
                    }
                    )}
                  </div>
                )}
              </div>
{filters?.export && (
                <button
                  className="pt-1 pb-1 w-120 Poppins_500"
                  id="button"
                  onClick={handleExport}
                  style={{ height: "34px" }}
                  disabled={loading}
                >
                  <img src={Export} alt="export"/>
                  &nbsp; Export
                        {loading ? (
        <span
          className="spinner-border spinner-border-sm ms-2"
          role="status"
          aria-hidden="true"
        ></span>
      ) :null}
                </button>
              )}
              {filters?.isAdd && filters?.isAddtitle && (
                <button
                  className="pt-1 pb-1 ps-3 pe-3 Poppins_500"
                  id="button"
                  onClick={() =>{
                  navigate(filters?.isAddLink)
                        dispatch(ClearFormSetFutios({
                        url: "",
                        action: ""
                    }))
                  } 
                  }
                >
                  + {filters?.isAddtitle} 
                </button>
              )}
              
            </div>
          </div>
          <div className="filter-scroll-container d-flex w-100 justify-content-between  align-items-center  mb-2 mt-2 pl">
            <div className="d-flex  align-items-center gap-2">
              {filters?.fromDate && filters?.toDate &&(
              <div className="main_date_div">
                {filters?.fromDate && (
                  <div className="col-2" id="datepickField">
                    <DatePicker
                      selected={FromDate}
                      startDate={FromDate}
                      endDate={ToDate}
                      onChange={(date) => DateStartGet(date)}
                      // dateFormat="dd/MM/yyyy h:mm aa"
                      dateFormat="dd/MM/yyyy"
                      maxDate={today}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="From Date"
                      showTimeSelect
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormatCalendar="MMMM"
                      isClearable={
                        FromDate !== "" && FromDate !== null ? true : false
                      }
                    />
                  </div>
                )}
                {filters?.fromDate && filters?.toDate && (
                  <span style={{ color: "#D9D9D9" }}> |</span>
                )}
                {filters?.toDate && (
                  <div className="col-2 " id="datepickField">
                    <DatePicker
                      selected={ToDate}
                      startDate={FromDate}
                      endDate={ToDate}
                      minDate={FromDate}
                      onChange={(date) => DateEndGet(date)}
                      // dateFormat="dd/MM/yyyy h:mm aa"
                      dateFormat="dd/MM/yyyy"
                      maxDate={today}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      showTimeSelect
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormatCalendar="MMMM"
                      dropdownMode="select"
                      placeholderText="To Date"
                      isClearable={ToDate !== "" ? true : false}
                    />
                  </div>
                )}
              </div>)}
              {filters?.period && (
                <div className="col-2 " style={{ width: "140px" }}>
                  <Select
                    value={period}
                    onChange={(e) => callHandleChange(e)}
                    options={periodOptions}
                    isClearable
                    classNamePrefix="godown-select"
                    placeholder="All"
                  />
                </div>
              )}
              {filters?.userSelect && (
                <div className="col-3 w-150">
                  <Select
                    value={optionVal}
                    onChange={(e) => RegionValueSelect(e)}
                    options={filters.userOptions || []}
                    isClearable
                    classNamePrefix="godown-select "
                    placeholder={`${filters?.userFilterlabel ? filters?.userFilterlabel :"Select User"}`}
                  />
                </div>
              )}

              {filters?.userRecipient && (
                <div className="col-3 w-150">
                  <Select
                    value={recipient}
                    onChange={(e) => RecipientChange(e)}
                    options={filters.userOptionsForRecipient || []}
                    isClearable
                    classNamePrefix="godown-select "
                    placeholder={"Recipient"}
                  />
                </div>
              )}
              {filters?.userActive && (
                <div className="col-4 d-flex align-items-center gap-2 w-150">
                  <div style={{ width: "160px" }}>
                    <Select
                      // value={active}
                      onChange={handleChange}
                      options={filters.userOptionsForActive}
                      isClearable
                      classNamePrefix="godown-select w-120"
                      placeholder="All"
                    />
                  </div>
                </div>
              )}
              {filters?.reset &&(
              <p
                  className="Poppins_400 reset_button"
                //  onClick={() => (ResetFilter())}
                onClick={ResetFilter}
                >
                  Reset{" "}
              </p>)}
            </div>
          </div>
        </>
      )}
<div className="layout-content2 ">
      <Scrollbars
        style={{
          height:
            Number(paginationObject?.total_records) > 20
              ?   `calc(100vh - ${height ?  height :"200px"})`
              : `calc(100vh - ${height ?  height :"140px"})`,
        }}
        renderView={(props) => <div {...props} className="view" />}
        className="ScrollbarsSidebar"
      >
        <Table  className="reusable-table">
          <thead
            style={{ position: "sticky", top: "0", backgroundColor: "#fff" }}
          >
            <tr className="user-management-table-heading">
              {headers
                ?.filter((header) => visibleColumns.includes(header?.key))
                ?.map(
                (header, idx) =>
                  (<th key={idx}>{header?.name}</th>)
              )}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data?.map((item, index) =>renderRow(item, index,visibleColumns))
            ) : (
              <tr>
                <td colSpan={headers?.length}>Data not found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Scrollbars>
      {Number(paginationObject?.total_records) > 20 && (
        <div className="mt-3 d-flex justify-content-start ms-3">
          <CommonPagination
            currentPage={currentPage}
            paginationLength={paginationObject}
            currentFunction={handlePageChange}
          />
        </div>
      )}
</div>
    </div>
  );
};

export default ReusableTable;
